export default __webpack_public_path__ + "static/media/IMG_9352.4c3c0a16.jpg";